// About Page Content - Adapted from iAngels.com

export const aboutContent = {
  hero: {
    title: "Venture Beyond",
    subtitle: "We are Angels67, Your Gateway to Investing in Israeli Innovation",
    description: "A women-led venture capital platform based in Tel Aviv, Israel, connecting investors with the most promising Israeli tech startups."
  },

  stats: {
    aum: "$400M+",
    exits: "24",
    members: "20,000+",
    companies: "150+"
  },

  mission: {
    title: "We are Angels67",
    content: `Founded to support Israeli tech entrepreneurs, Angels67 emphasizes going "beyond" conventional venture investing. We highlight a deep, proprietary-research process and curated portfolio approach.

    Our platform democratizes access to Israeli innovation, allowing individual investors to participate in the venture capital ecosystem that was previously accessible only to institutional investors.`
  },

  founders: [
    {
      name: "Shelly Hod Moyal",
      title: "Co-Founder & Managing Partner",
      bio: "Venture capital leader with extensive experience in Israeli tech ecosystem.",
      image: "https://ui-avatars.com/api/?name=Shelly+Hod+Moyal&background=4F46E5&color=fff&size=200"
    },
    {
      name: "Mor Assia",
      title: "Co-Founder & Managing Partner",
      bio: "Strategic investor focused on high-growth technology companies.",
      image: "https://ui-avatars.com/api/?name=Mor+Assia&background=10B981&color=fff&size=200"
    }
  ],

  services: [
    {
      id: 1,
      name: "Angels67 Capital",
      description: "A self-directed account for the sophisticated investor with access to all due-diligence materials.",
      features: [
        "Full access to due diligence materials",
        "Direct investment opportunities",
        "Transparent fee structure",
        "Portfolio management tools"
      ],
      icon: "💼"
    },
    {
      id: 2,
      name: "Angels67 Ventures",
      description: "A professionally tailored and diversified 'personal fund' built with you and for you.",
      features: [
        "Professionally managed portfolio",
        "Personalized investment strategy",
        "Diversified across sectors",
        "Expert guidance and support"
      ],
      icon: "🎯"
    },
    {
      id: 3,
      name: "Angels67 Digital Assets",
      description: "An actively managed fund dedicated to Blockchain-based assets.",
      features: [
        "Blockchain technology focus",
        "Actively managed fund",
        "Crypto and Web3 opportunities",
        "Professional asset management"
      ],
      icon: "⛓️"
    }
  ],

  values: [
    {
      title: "Innovation First",
      description: "We invest in groundbreaking technologies that shape the future."
    },
    {
      title: "Transparency",
      description: "Full access to due diligence and investment materials for all members."
    },
    {
      title: "Community Driven",
      description: "Building a community of investors supporting Israeli innovation."
    },
    {
      title: "Expert Curation",
      description: "Deep research process ensures only the most promising opportunities."
    }
  ],

  contact: {
    address: "Rothschild Blvd 18, Tel Aviv, 6688121, Israel",
    phone: "+972 3 901 3760",
    email: "team@angels67.com"
  },

  press: [
    { name: "TechCrunch", logo: "📰" },
    { name: "Fortune", logo: "📈" },
    { name: "Bloomberg", logo: "💼" },
    { name: "Forbes", logo: "🏆" }
  ]
};

export default aboutContent;
